import { useQuery } from "react-query";
import { useRouter } from "../../useRouter";
import { useApiError } from "src/hooks/useApiError";
import { getMyServiceBill, getPriceList } from "src/service/pay";
import { useState } from "react";
import { getProductFromSessionStorage } from "src/utils/storage/auth";

interface IUseTotalNxacListProps {
  enabled?: boolean;
  onSuccess?: (serviceList: any) => void;
  onError?: () => void;
}
// Bill페이지 에서 사용할 구매이력 정보
export function useMyServiceBill({
  enabled = true,
  onSuccess,
  onError,
}: IUseTotalNxacListProps) {
  const { handleError } = useApiError();
  const { goConsole } = useRouter();
  const [isAvailable, setIsAvailable] = useState<boolean>(false);
  const route = useRouter();
  // 내가 구매한 요금제 정보
  const { isLoading: isLoadingMyServiceBill, data: myServiceBill } = useQuery(
    [`getMyServiceBill-${route.currentPath}`, getProductFromSessionStorage()],
    async () =>
      await getMyServiceBill({ product: getProductFromSessionStorage() }),
    {
      // refetchOnMount: true, // 컴포넌트가 마운트될 때마다 쿼리를 리페치할지 여부를 나타내는 플래그
      // refetchOnWindowFocus: true, // 윈도우가 포커스를 받을 때마다 쿼리를 리페치할지 여부를 나타내는 플래그
      enabled: enabled && getProductFromSessionStorage() !== null,
      onSuccess: onSuccess ? onSuccess : (res) => {},
      onError: handleError,
    }
  );

  return { isLoadingMyServiceBill, myServiceBill };
}
